// Auto-growing textareas often stand in for single-line inputs (so long values wrap
// and grow instead of scrolling out of view). Blocking Enter keeps their value single-line.
export const blockNewlineKey = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
  }
};
